import { DefaultVendorToEdit } from 'contexts/vendor.context/provider';
import { ENUM_PAYMENT_STATUS } from './common.model';
import { VendorType } from './vendors.model';
import { IngredientListType } from './pricing.model';

export const DefaultPaymentType = {
  id: '',
  vendor_id: '',
  type: '',
  amount: '',
  old_balance: '',
  new_balance: '',
  created_at: '',
  updated_at: '',
  status: ENUM_PAYMENT_STATUS.PENDING,
  code: '',
  payment_due: '',
  payment_date: '',
  vendor: DefaultVendorToEdit
};

export type PaymentType = {
  id: string;
  vendor_id: string;
  type: string;
  amount: string;
  old_balance: string;
  new_balance: string;
  created_at: string;
  updated_at: string;
  status: ENUM_PAYMENT_STATUS;
  code: string;
  payment_due: string;
  payment_date: string;
  vendor: VendorType;
};

export enum UPDATE_PAYMENT_ACTIONS {
  APPROVE = 'Approve',
  REJECT = 'Reject',
  COMPLETE = 'complete',
  NONE = ''
}

export type ProcurementRequestType = {
  id: string;
  title: string;
  note: string;
  status: string;
  created_at: string;
  updated_at: string;
  quantity_returned: number;
  expected_cost: string;
  cost_of_received_items: string;
  request_index: number;
  store_id: string;
  code: number;
};

export type PaymentRequestItemType = {
  id: string;
  procurement_request_id: string;
  ingredient_id: string;
  vendor_id: string;
  quantity: number;
  price: string;
  paid: boolean;
  quantity_received: number;
  payment_status: string;
  vendor_transaction_id: string | null;
  created_at: string;
  updated_at: string;
  completed: boolean;
  status: string;
  quantity_returned: number;
  invoice_url: string | null;
  procurement_request: ProcurementRequestType;
  ingredient: IngredientListType;
};

export type PaymentRequestDetailType = {
  id: string;
  vendor_id: string;
  amount: string;
  status: string;
  receipt_url: string | null;
  note: string | null;
  vendor_transaction_id: string | null;
  created_at: string;
  updated_at: string;
  payment_due_date: string;
  item_transaction_id: string;
  request_item_id: string;
  code: number;
  vendor: VendorType;
  request_item: PaymentRequestItemType;
};
